import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { closeIcon } from "../../../../assets/svg";
import "./style.css";
import makeRequest from "../../../../api";
import { nutritionApiService } from "../../../../api/services";
import { toast } from "react-toastify";

interface mealPlanModal {
  open: boolean;
  setOpen: (target: boolean) => void;
  mealType: any;
  date: any;
  mealPlan: any;
  updateMealPlan: any;
  userResponses: any;
  mealTypeLabel: any;
}
const AddDishModal = ({
  open,
  setOpen,
  mealType,
  date,
  mealPlan,
  updateMealPlan,
  userResponses,
  mealTypeLabel,
}: mealPlanModal) => {
  const [searchedValue, setSearchedValue] = useState("");
  const [searchedDishes, setSearchedDishes] = useState<any[]>([]);
  const [selectedDish, setSelectedDish] = useState<any>({});
  const [servingCount, setServingCount] = useState(1);
  const [servingSize, setServingSize] = useState("");
  const [servingQuantity, setServingQuantity] = useState(0);
  const [protein, setProtein] = useState(0);
  const [calorie, setCalorie] = useState(0);
  const [carbs, setCarbs] = useState(0);
  const [fibre, setFibre] = useState(0);
  const [fat, setFat] = useState(0);
  const [fattyAcidTotalSaturated, setFattyAcidTotalSaturated] = useState(0);
  const [sodium, setSodium] = useState(0);
  const [unit, setUnit] = useState("");
  const [searchDetail, setSearchDetail] = useState(false);

  useEffect(() => {
    if (servingSize !== "") {
      const x = selectedDish?.servingInfo?.filter(
        (a: any) => a.size === servingSize
      );
      setServingQuantity(
        x[0]?.serving_qty !== 0
          ? x[0]?.serving_qty
          : selectedDish?.recipe?.standard_values_in_grams
      );
    }
  }, [servingSize, selectedDish]);

  useEffect(() => {
    if (selectedDish?.recipe?.standard_values_in_grams === 1) {
      let p =
        servingCount * servingQuantity * selectedDish?.recipe?.macro?.protein;
      p = +p.toFixed(3);
      setProtein(p);
      let c =
        servingCount * servingQuantity * selectedDish?.recipe?.macro?.calorie;
      c = +c.toFixed(3);
      setCalorie(c);
      let carbs =
        servingCount * servingQuantity * selectedDish?.recipe?.macro?.carbs;
      carbs = +carbs.toFixed(3);
      setCarbs(carbs);
      let fibre =
        servingCount * servingQuantity * selectedDish?.recipe?.micro?.fibre;
      fibre = +fibre.toFixed(3);
      setFibre(fibre);
      let fat =
        servingCount * servingQuantity * selectedDish?.recipe?.macro?.fat;
      fat = +fat.toFixed(3);
      setFat(fat);
      let fattyAcidTotalSaturated =
        servingCount *
        servingQuantity *
        selectedDish?.recipe?.micro?.fatty_acids_total_saturated;
      fattyAcidTotalSaturated = +fattyAcidTotalSaturated.toFixed(3);
      setFattyAcidTotalSaturated(fattyAcidTotalSaturated);
      let sodium =
        servingCount * servingQuantity * selectedDish?.recipe?.micro?.sodium;
      sodium = +sodium.toFixed(3);
      setSodium(sodium);
    } else {
      let p = servingCount * selectedDish?.recipe?.macro?.protein;
      p = +p.toFixed(3);
      setProtein(p);
      let c = servingCount * selectedDish?.recipe?.macro?.calorie;
      c = +c.toFixed(3);
      setCalorie(c);
      let carbs = servingCount * selectedDish?.recipe?.macro?.carbs;
      carbs = +carbs.toFixed(3);
      setCarbs(carbs);
      let fibre = servingCount * selectedDish?.recipe?.micro?.fibre;
      fibre = +fibre.toFixed(3);
      setFibre(fibre);
      let fat = servingCount * selectedDish?.recipe?.macro?.fat;
      fat = +fat.toFixed(3);
      setFat(fat);
      let fattyAcidTotalSaturated =
        servingCount * selectedDish?.recipe?.micro?.fatty_acids_total_saturated;
      fattyAcidTotalSaturated = +fattyAcidTotalSaturated.toFixed(3);
      setFattyAcidTotalSaturated(fattyAcidTotalSaturated);
      let sodium = servingCount * selectedDish?.recipe?.micro?.sodium;
      sodium = +sodium.toFixed(3);
      setSodium(sodium);
    }
  }, [servingQuantity, servingCount, selectedDish]);

  useEffect(() => {
    setServingQuantity(selectedDish?.recipe?.standard_values_in_grams);
    setUnit(selectedDish?.servingInfo?.[0]?.serving_unit);
  }, [selectedDish]);

  const onClose = () => {
    setOpen(false);
    clear();
  };
  const clear = () => {
    setSearchedValue("");
    setSearchedDishes([]);
    setSelectedDish({});
    setServingCount(1);
    setServingSize("");
    setServingQuantity(0);
    setProtein(0);
    setCalorie(0);
    setFibre(0);
    setCarbs(0);
    setFat(0);
    setFattyAcidTotalSaturated(0);
    setSodium(0);
    setUnit("");
  };

  useEffect(() => {
    if (searchedValue.length > 2) {
      let mealPreference: string[] = [];
      let cuisine: string[] = [];
      let medicalConditions: string[] = [];

      let options = userResponses?.cuisine_types?.optionsSelected;
      for (let i = 0; i < options?.length; ++i) {
        if (options?.[i] === "veg") {
          mealPreference?.push("Veg");
          cuisine?.push(
            ...(userResponses?.["veg_region_cuisine"]?.optionsSelected || [])
          );
        } else if (options?.[i] === "nonveg") {
          mealPreference?.push("Nonveg");
          mealPreference?.push("Veg");
          mealPreference?.push("Egg");
          cuisine?.push(
            ...(userResponses?.["nonveg_region_cuisine"]?.optionsSelected || [])
          );
        } else if (options?.[i] === "egg") {
          mealPreference?.push("Egg");
          mealPreference?.push("Veg");
          cuisine?.push(
            ...(userResponses?.["egg_region_cuisine"]?.optionsSelected || [])
          );
        }
      }

      let regions: string[] = ["Common"];
      for (let i = 0; i < cuisine?.length; ++i) {
        if (cuisine?.[i] === "north") {
          regions.push("NorthIndia");
        } else if (cuisine?.[i] === "south") {
          regions.push("SouthIndia");
        } else if (cuisine?.[i] === "east") {
          regions.push("EastIndia");
        } else if (cuisine?.[i] === "west") {
          regions.push("WestIndia");
        }
      }

      medicalConditions.push(
        ...(userResponses?.["conditions_nutrition"]?.optionsSelected || [])
      );

      const searchRecipes = async () => {
        let mealTimes = [mealTypeLabel];
        if (mealTypeLabel === "EarlyMorning") {
          mealTimes.push("Snacks");
        }

        let body = {
          text: searchedValue,
          mealTime: mealTimes,
          medicalCondition: medicalConditions,
          allergens: [],
          dislikes: [],
          mealPreference: mealPreference,
          region: [],
          searchDetail: searchDetail,
          limit: 70,
        };
        try {
          const res = await makeRequest(
            nutritionApiService.getAllRecipeList(body)
          );
          setSearchedDishes([...(res?.data?.data || [])]);
        } catch (error: any) {
          toast.error("Error fetching recipe list");
        }
      };
      searchRecipes();
    } else {
      setSearchedDishes([]);
    }
  }, [searchedValue, mealTypeLabel, searchDetail, userResponses]);

  const handleSubmit = (e: any) => {
    e.preventDefault();

    mealPlan?.forEach((item: any) => {
      if (item?.date === date) {
        let idx = -1;
        item?.meals?.forEach((x: any, index: any) => {
          if (x?.mealType === mealType) {
            x?.dishes?.push({
              fat: fat,
              fattyAcidTotalSaturated: fattyAcidTotalSaturated,
              sodium: sodium,
              fibre: fibre,
              carbs: carbs,
              calorie: calorie,
              colorCode: 0,
              id: selectedDish?.recipe?._id,
              imageUrl: selectedDish?.recipe?.imageUrl,
              name: selectedDish?.recipe?.name,
              protein: protein,
              unitCount: servingCount,
              unitName: selectedDish?.recipe?.unit_name,
              unitSize: servingSize,
              veg_nonveg: selectedDish?.recipe?.veg_nonveg,
              standard_values_in_grams:
                selectedDish?.recipe?.standard_values_in_grams,
              totalQuantity: servingQuantity * servingCount,
              type: selectedDish?.recipe?.change_dish_tag,
              recipe: selectedDish?.recipe,
            });
            idx = index;
          }
        });
        if (idx === -1) {
          item?.meals?.push({
            calorieIntake: 0,
            dishes: [
              {
                fat: fat,
                fattyAcidTotalSaturated: fattyAcidTotalSaturated,
                sodium: sodium,
                fibre: fibre,
                carbs: carbs,
                calorie: calorie,
                colorCode: 0,
                id: selectedDish?.recipe?._id,
                imageUrl: selectedDish?.recipe?.imageUrl,
                name: selectedDish?.recipe?.name,
                protein: protein,
                unitCount: servingCount,
                unitName: selectedDish?.recipe?.unit_name,
                unitSize: servingSize,
                veg_nonveg: selectedDish?.recipe?.veg_nonveg,
                totalQuantity: servingQuantity * servingCount,
                standard_values_in_grams:
                  selectedDish?.recipe?.standard_values_in_grams,
                type: selectedDish?.recipe?.change_dish_tag,
                recipe: selectedDish?.recipe,
              },
            ],
            mealScore: 0,
            mealType: mealType,
            proteinIntake: 0,
          });
        }
      }
    });
    updateMealPlan(mealPlan);
    setOpen(false);
    clear();
  };

  return (
    <Modal
      show={open}
      //   centered={windowView === SCREEN_TYPE.MD_VIEW}
      className="desktop-modal meal-modal"
    >
      <Modal.Header>
        <Modal.Title className="heading">
          Add Dish for {mealType} on {date}
        </Modal.Title>
        <div onClick={onClose}>
          <img src={closeIcon} alt="close-icon" />
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="add-meal">
          <form action="" onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <label htmlFor="" className="mb-2">
                Dish Name
              </label>
              <div className="custom-search-container">
                <input
                  type="text"
                  className="form-control"
                  value={searchedValue}
                  onChange={(e) => {
                    setSearchDetail(false);
                    setSearchedValue(e.target.value);
                  }}
                />
                {searchedDishes?.length > 0 &&
                  searchedValue?.toLowerCase() !==
                    selectedDish?.recipe?.name?.toLowerCase() && (
                    <div className="custom-dropdown">
                      {searchedDishes?.map((item, index) => (
                        <div
                          className="custom-dropdown-item px-3"
                          key={index}
                          onClick={() => {
                            setSelectedDish(item);
                            setSearchedValue(item?.recipe?.name);
                            setSearchDetail(true);
                          }}
                        >
                          {item?.recipe?.name}
                        </div>
                      ))}
                    </div>
                  )}
              </div>
            </div>
            <div className="form-group mb-3">
              <label htmlFor="" className="mb-0">
                Serving Unit
              </label>
              <input
                type="text"
                disabled
                className="form-control"
                value={selectedDish?.recipe?.unit_name}
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="" className="mb-2">
                Serving Count
              </label>
              {selectedDish?.recipe?.unit_name === "Scoop" ? (
                <input
                  type="number"
                  className="form-control"
                  value={servingCount}
                  onChange={(e) => setServingCount(+e.target.value)}
                  min={0.5}
                  max={10}
                  step={0.5}
                />
              ) : (
                <input
                  type="number"
                  className="form-control"
                  value={servingCount}
                  onChange={(e) => setServingCount(+e.target.value)}
                  min={1}
                  max={10}
                />
              )}
            </div>
            {/* {selectedDish?.servingInfo?.length > 1 && ( */}
            <div className="form-group mb-3">
              <label htmlFor="" className="mb-2">
                Serving Size
              </label>
              <select
                name=""
                id=""
                className="form-select"
                onChange={(e) => {
                  setServingSize(e.target.value);
                }}
                defaultValue={""}
              >
                <option value="">Not Selected</option>
                {selectedDish?.servingInfo?.map((item: any, index: any) => {
                  return (
                    <option value={item?.size} key={index + 1}>
                      {item?.size}
                    </option>
                  );
                })}
              </select>
            </div>
            {/* )} */}
            <button className="btn btn-outline-secondary">Add Dish</button>
          </form>
        </div>
        {Object.keys(selectedDish)?.length !== 0 && (
          <div className="mt-4">
            <p className="mb-2">
              <span>
                Serving Quantity : {servingQuantity} {unit}
              </span>
            </p>
            <p className="mb-2">
              <span>
                Total Quantity : {servingQuantity * servingCount} {unit}
              </span>
            </p>
            <p className="mb-2">
              <span>Total Protein : {protein}</span>
            </p>
            <p className="mb-2">
              <span>Total Calorie : {calorie}</span>
            </p>
            {/* <p className="mb-2">
              <span>Total Carbs : {carbs}</span>
            </p>
            <p className="mb-2">
              <span>Total Fibre : {fibre}</span>
            </p> */}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AddDishModal;
